import useStyle, { Provider } from './useStyle';

export { Provider };
export default useStyle;
